import * as types from "./types";
import * as actions from "store/actions";

export function fetchVMsListStart(showReloading = true) {
  return {
    type: types.FETCH_VIRTUAL_MACHINES_LIST_START,
    showReloading: showReloading
  };
}

export function fetchVMsListSuccess(data) {
  return {
    type: types.FETCH_VIRTUAL_MACHINES_LIST_SUCCESS,
    data
  };
}

export function fetchVMsListFailure(status, msg) {
  return {
    type: types.FETCH_VIRTUAL_MACHINES_LIST_FAILURE,
    status,
    msg
  };
}

export function createVMTaskStart(data, redirect) {
  return {
    type: types.CREATE_VIRTUAL_MACHINE_TASK_START,
    data,
    redirect
  };
}

export function createVMTaskSuccess(taskId, clientUUID, redirect) {
  return {
    type: types.CREATE_VIRTUAL_MACHINE_TASK_SUCCESS,
    taskId,
    clientUUID,
    redirect
  };
}

export function createVMTaskFailure() {
  return {
    type: types.CREATE_VIRTUAL_MACHINE_TASK_FAILURE
  };
}

export function fetchTaskStatusListStart() {
  return {
    type: types.FETCH_TASK_STATUS_LIST_START
  };
}

export function fetchTaskStatusListSuccess(data) {
  return {
    type: types.FETCH_TASK_STATUS_LIST_SUCCESS,
    data
  };
}

export function fetchTaskStatusListFailure(data) {
  return {
    type: types.FETCH_TASK_STATUS_LIST_FAILURE,
    data
  };
}

export function createVmTaskIdList(data) {
  return {
    type: types.CREATE_VM_TASK_ID_LIST,
    data
  };
}

export function updateTaskStatus(data) {
  return {
    type: types.UPDATE_TASK_STATUS,
    data
  };
}

export function controlVMStart(data) {
  return {
    type: types.CONTROL_VM_START,
    data
  };
}

export function controlVMSuccess(response, data) {
  return {
    type: types.CONTROL_VM_SUCCESS,
    response,
    data
  };
}

export function controlVMFailure(response, data) {
  return {
    type: types.CONTROL_VM_FAILURE,
    response,
    data
  };
}

export function deleteVMStart(data) {
  return {
    type: types.DELETE_VM_START,
    data
  };
}

export function deleteVMSuccess(data) {
  return {
    type: types.DELETE_VM_SUCCESS,
    data
  };
}

export function deleteVMFailure(data) {
  return {
    type: types.DELETE_VM_FAILURE,
    data
  };
}

export function fetchVIRTRecoveryPointsStart(clientUUID, restore) {
  return {
    type: types.FETCH_VIRT_RECOVERY_POINTS_START,
    clientUUID,
    restoreType: restore.type,
    scheduleUUID: restore.scheduleUUID,
    params: {
      onMount: restore.onMount,
      serverIPAddress: restore.serverIPAddress
    }
  };
}

export function fetchVIRTRecoveryPointsSuccess(points, params) {
  return {
    type: types.FETCH_VIRT_RECOVERY_POINTS_SUCCESS,
    points,
    params
  };
}

export function fetchVIRTRecoveryPointsFailure(data, params) {
  return {
    type: types.FETCH_VIRT_RECOVERY_POINTS_FAILURE,
    data,
    params
  };
}

export function resetSliderConfigs() {
  return {
    type: types.RESET_SLIDER_CONFIGS
  };
}

export function updateVMConfigurationsStart(data) {
  return {
    type: types.UPDATE_VM_CONFIGURATIONS_START,
    data
  };
}

export function updateVMConfigurationsSuccess(data) {
  return {
    type: types.UPDATE_VM_CONFIGURATIONS_SUCCESS,
    data
  };
}

export function updateVMConfigurationsFailure(data) {
  return {
    type: types.UPDATE_VM_CONFIGURATIONS_FAILURE,
    data
  };
}

export function rebuildVMStart(vm_uuid, hostname) {
  return {
    type: types.REBUILDVM_START,
    vm_uuid,
    hostname
  };
}

export function rebuildVMSuccess(data, vm_uuid) {
  return {
    type: types.REBUILDVM_SUCCESS,
    data,
    vm_uuid
  };
}

export function rebuildVMFailure(vm_uuid) {
  return {
    type: types.REBUILDVM_FAILURE,
    vm_uuid
  };
}

export function fetchVirtUserInfoStart() {
  return {
    type: types.VIRT_USER_INFO_START
  };
}

export function fetchVirtUserInfoSuccess(data) {
  return {
    type: types.VIRT_USER_INFO_SUCCESS,
    data
  };
}

export function fetchVirtUserInfoFailure() {
  return {
    type: types.VIRT_USER_INFO_FAILURE
  };
}

export function fetchVirtUserInfoFailureRetry() {
  return dispatch => {
    let timer = null;
    dispatch(actions.createVirtualizationAccountStart());

    timer = setTimeout(() => {
      dispatch(actions.fetchVirtUserInfoStart());
      dispatch(actions.fetchVMsListStart());
      clearTimeout(timer);
    }, 2500);
  };
}

export function closeSSEConnection() {
  return {
    type: types.CLOSE_SSE_CONNECTION
  };
}

export function setRpcMachineStatusVi(data) {
  return {
    type: types.SET_RPC_MACHINE_STATUS_VI,
    data
  };
}

export function setRpcSocketDetails(data) {
  return {
    type: types.SET_RPC_SOCKET_DETAILS_VI,
    data
  };
}

export function setRPCConsoleAccessInProgress(clientUUID, taskId) {
  return {
    type: types.RPC_CONSOLE_ACCESS_IN_PROGRESS,
    clientUUID,
    taskId
  };
}

export function setRPCConsoleBootProgress(clientUUID, notifMsg) {
  return {
    type: types.RPC_CONSOLE_BOOT_PROGRESS,
    clientUUID,
    notifMsg
  };
}

export function logoutVirtInstances() {
  return {
    type: types.LOGOUT_VIRT_INSTANCES
  };
}

export function logoutSingleVirtInstances(clientUUID) {
  return {
    type: types.LOGOUT_SINGLE_VIRT_INSTANCES,
    clientUUID
  };
}
